// extracted by mini-css-extract-plugin
export var osc = "osc-module--osc--3ukLI";
export var dial = "osc-module--dial--IMVBG";
export var slider = "osc-module--slider--2eMwE";
export var noselect = "osc-module--noselect--20YfY";